import React, { useState } from "react";
import { getCourseMap, addCourseRule, deleteCourseRule, getGoal, updateGoal, getIngestStatus } from "../api/services";
import { useData } from "../hooks/useData";
import { Card, Loading, Button } from "../components/common/UI";
import { IconPlus, IconTrash } from "../components/common/Icons";
import { fmtDate } from "../utils/format";
import styles from "./pages.module.css";

const PRODUCTS = ["minecraftia", "robotehnick", "maska", "rublox", "startklass"];

export default function Settings() {
  const map = useData(getCourseMap, []);
  const goal = useData(getGoal, []);
  const ingest = useData(getIngestStatus, []);
  const [pattern, setPattern] = useState("");
  const [product, setProduct] = useState("minecraftia");
  const [targetRub, setTargetRub] = useState("");

  if (map.loading || goal.loading) return <Loading />;
  const rules = map.data?.rules || [];
  const g = goal.data || {};
  const last = ingest.data?.last;

  const addRule = async () => {
    if (!pattern.trim()) return;
    await addCourseRule({ pattern: pattern.trim(), product });
    setPattern("");
    map.reload();
  };
  const removeRule = async (id) => {
    await deleteCourseRule(id);
    map.reload();
  };
  const saveTarget = async () => {
    const kop = Math.round(Number(targetRub) * 100);
    if (kop > 0) {
      await updateGoal({ target_mrr_kop: kop });
      goal.reload();
      setTargetRub("");
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.pageHead}>
        <div>
          <h1 className={styles.pageTitle}>Настройки</h1>
          <div className={styles.pageSub}>Атрибуция оплат курсов, цель, статус сбора данных</div>
        </div>
      </div>

      <Card title="Цель по выручке">
        <div style={{ marginBottom: 12, color: "var(--text-dim)" }}>
          Текущая цель: <b style={{ color: "var(--text)" }}>{(g.target_mrr_kop / 100).toLocaleString("ru-RU")} ₽</b>
          {g.deadline_date && <> · дедлайн {fmtDate(g.deadline_date)}</>}
        </div>
        <div className={styles.toolbar}>
          <input placeholder="Новая цель, ₽" type="number" value={targetRub}
                 onChange={(e) => setTargetRub(e.target.value)} style={{ maxWidth: 200 }} />
          <Button onClick={saveTarget}>Обновить цель</Button>
        </div>
      </Card>

      <Card title="Атрибуция оплат курсов по направлениям">
        <div style={{ color: "var(--text-dim)", fontSize: 13, marginBottom: 14 }}>
          Оплаты из журнала курсов относятся к продукту по названию группы ученика (подстрока-паттерн).
          Сейчас все оплаты курсов (робототехника, программирование, математика) учитываются как
          онлайн-оплаты Майнкрафтии.
        </div>
        <div className={styles.toolbar} style={{ marginBottom: 16 }}>
          <input placeholder="подстрока названия группы" value={pattern}
                 onChange={(e) => setPattern(e.target.value)} style={{ maxWidth: 260 }} />
          <select value={product} onChange={(e) => setProduct(e.target.value)} style={{ maxWidth: 180 }}>
            {PRODUCTS.map((p) => <option key={p} value={p}>{p}</option>)}
          </select>
          <Button onClick={addRule}><IconPlus width={15} height={15} /> Добавить</Button>
        </div>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ textAlign: "left", color: "var(--text-dim)", fontSize: 12.5 }}>
              <th style={{ padding: "6px 4px" }}>Паттерн</th>
              <th>Продукт</th>
              <th>Тип</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {rules.map((r) => (
              <tr key={r.id} style={{ borderTop: "1px solid var(--border)" }}>
                <td style={{ padding: "8px 4px", fontFamily: "monospace" }}>{r.pattern}</td>
                <td>{r.product}</td>
                <td style={{ color: "var(--text-mute)" }}>{r.is_auto ? "авто" : "вручную"}</td>
                <td style={{ textAlign: "right" }}>
                  <button onClick={() => removeRule(r.id)}
                          style={{ background: "none", border: "none", color: "var(--text-mute)", padding: 6 }}>
                    <IconTrash width={15} height={15} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>

      <Card title="Статус сбора данных">
        {last ? (
          <div>
            <div style={{ marginBottom: 8 }}>
              Последний сбор: <b>{last.status === "ok" ? "успех" : last.status === "partial" ? "частично" : "ошибка"}</b>
              {last.finished_at && <> · {fmtDate(last.finished_at)}</>}
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              {Object.entries(last.sources || {}).map(([k, v]) => (
                <span key={k} style={{ background: "var(--bg)", border: "1px solid var(--border)", borderRadius: 20, padding: "3px 10px", fontSize: 12 }}>
                  {k}: {typeof v === "object" ? v.status || "ok" : v}
                </span>
              ))}
            </div>
            {last.sources?.revenue?.unresolved_groups?.length > 0 && (
              <div style={{ marginTop: 14, color: "var(--amber)", fontSize: 13 }}>
                Нераспознанные группы (ушли в Майнкрафтию по умолчанию, добавь правила выше):{" "}
                {last.sources.revenue.unresolved_groups.join(", ")}
              </div>
            )}
          </div>
        ) : (
          <div style={{ color: "var(--text-mute)" }}>Сбор ещё не запускался. Нажми «Обновить данные» вверху.</div>
        )}
      </Card>
    </div>
  );
}
